window.quantites = []
document.addEventListener("DOMContentLoaded", function() {
 let variant_selectors = document.querySelectorAll('.test_select');
 variant_selectors.forEach((variant_selector) => {
    variant_selector.addEventListener('change', () => {
        // Skip if it's the default "Select a flavor" option
        if(variant_selector.selectedIndex === 0) return;
        
        const selectedOption = variant_selector.children[variant_selector.selectedIndex];
        if(!selectedOption || !selectedOption.dataset.variantid) return;
        
        const variantId = selectedOption.dataset.variantid;
        const variantPrice = Number(selectedOption.dataset.price) / 100; // Convert from cents to dollars
        
        // Check if variant is already in bundle
        if(isInBundle(variantId) != -1) {
            alert('This variant is already in your bundle.');
            variant_selector.selectedIndex = 0; // Reset to default
            return;
        }
        
        // Check if bundle is full
        if(getTotalBundleSize() >= window.BundleSize) {
            alert('Your bundle is full. Please remove an item to add another.');
            variant_selector.selectedIndex = 0; // Reset to default
            return;
        }
        
        // Get product image from the product grid item
        const productItem = variant_selector.closest('.product-grid-item');
        const productImage = productItem ? productItem.querySelector('.product-image') : null;
        let imageUrl = '';
        
        if (productImage && productImage.src) {
            // Ensure we have a full URL
            imageUrl = productImage.src;
            if (imageUrl.startsWith('//')) {
                imageUrl = window.location.protocol + imageUrl;
            } else if (imageUrl.startsWith('/')) {
                imageUrl = window.location.origin + imageUrl;
            }
        }
        
        // Add to bundle
        window.BundleInfo.push(bundleProduct(variantId, imageUrl, variantPrice, 1));
        
        // Hide variant selector and button, show quantity control
        variant_selector.style.display = "none";
        const addButton = productItem ? productItem.querySelector('.product-button') : null;
        if(addButton) {
            addButton.style.display = "none";
        }
        
        // Show and configure quantity control
        const quantityControl = productItem ? productItem.querySelector('.quantity-control') : null;
        if(quantityControl) {
            quantityControl.dataset.variant = variantId;
            quantityControl.style.display = "flex";
            const quantityInput = quantityControl.querySelector('.quantity-input');
            if(quantityInput) {
                quantityInput.value = 1;
                quantityInput.setAttribute('value', '1');
            }
        }
        
        // Mark product as selected
        if(addButton && addButton.dataset.handle) {
            productItem.classList.add(addButton.dataset.handle + "-selected");
        }
        
        // Update UI
        updatSelectedData();
    })
 })

 let options = document.querySelectorAll('.variant_option');

 options.forEach((option) => {
    if(option.dataset.variantid && option.dataset.max) {
    quantites.push({variantId: option.dataset.variantid, quantity: Number(option.dataset.max)})
    }
 })

  window.originalHeaderText = "";
});

function AddProductToBundle(self,isImg){
    if(isImg){
        let parent = self.parentElement;
        let quantity_selector = parent.querySelector(".quantity-control");

        if(quantity_selector && isInBundle(quantity_selector.dataset.variant) == -1 && getTotalBundleSize() < window.BundleSize){
            let button = parent.querySelector(".product-button");
            if(button) button.click();
        }
    }else{
        let quantity_selector = self.nextElementSibling;
        if(!quantity_selector || isInBundle(quantity_selector.dataset.variant) != -1 || getTotalBundleSize() >= window.BundleSize){
            return;
        }
        
            let variant_selector = document.querySelector(`.${self.dataset.handle}_variant_selector`);
        if(!variant_selector) return;
        
            self.style.display = "none"
        
        // Check if variant selector has only 2 options (default + one variant = 2 total)
        // If only one variant option, add directly; otherwise show selector
        const variantOptions = variant_selector.querySelectorAll('option.variant_option');
        if(variantOptions.length <= 1){
            // Only default variant or one variant, add directly
            // Get image from product grid item or button data attribute
            const productItem = self.closest('.product-grid-item');
            const productImage = productItem ? productItem.querySelector('.product-image') : null;
            let imageUrl = '';
            
            if (productImage && productImage.src) {
                imageUrl = productImage.src;
            } else if (self.dataset.img) {
                imageUrl = self.dataset.img;
            }
            
            // Ensure we have a full URL
            if (imageUrl) {
                if (imageUrl.startsWith('//')) {
                    imageUrl = window.location.protocol + imageUrl;
                } else if (imageUrl.startsWith('/')) {
                    imageUrl = window.location.origin + imageUrl;
                }
            }
            
            window.BundleInfo.push(bundleProduct(self.dataset.default, imageUrl, Number(self.dataset.price)/100, 1));
            
            // Hide button and show quantity control
            self.style.display = "none";
            const quantityControl = self.nextElementSibling;
            if(quantityControl && quantityControl.classList.contains('quantity-control')) {
                quantityControl.dataset.variant = self.dataset.default;
                quantityControl.style.display = "flex";
                const quantityInput = quantityControl.querySelector('.quantity-input');
                if(quantityInput) {
                    quantityInput.value = 1;
                    quantityInput.setAttribute('value', '1');
                }
            }
            
                updatSelectedData();
            self.parentElement.classList.add(self.dataset.handle + "-selected");
            }else{
            // Multiple variants, show selector
                variant_selector.style.display = "block"
            // Reset selected state
                for(let i = 0; i < variant_selector.children.length; i++){
                    let child  = variant_selector.children[i];
                    child.removeAttribute('selected')
                }
            if(variant_selector.children.length > 0){
                variant_selector.children[0].setAttribute('selected','')
            }
        }
    }
}

function changeQuantity(self){
    let isIncrementing = self.dataset.quantity_plus == "" ? true : false;
    let parent = self.parentElement;
    let quantity_display = parent.querySelector(".quantity-input");
    if(!quantity_display || !parent.dataset.variant) return;
    
    let bundleIndex = isInBundle(parent.dataset.variant);
    if(bundleIndex == -1) return;
    
    let bundle = window.BundleInfo[bundleIndex];
    if(!bundle) return;
    
    let inventory = window.quantites.find((variant) => variant.variantId == `${parent.dataset.variant}`);
    
    if(isIncrementing){ 
        const currentTotal = getTotalBundleSize();
        const maxQuantity = inventory ? inventory.quantity : 999;
        
        if(currentTotal < window.BundleSize && Number(bundle.quantity) < maxQuantity){
            bundle.quantity = `${Number(bundle.quantity) + 1}`;
        }
    }else{
        if(Number(bundle.quantity) > 1){
            bundle.quantity = `${Number(bundle.quantity) - 1}`;
        }else{
            // Remove from bundle if quantity would be 0
            parent.style.display = "none";
            // Find the add button - it could be before variant selector or before quantity control
            const productItem = parent.closest('.product-grid-item');
            if(productItem) {
                const addButton = productItem.querySelector('.product-button');
                const variantSelector = productItem.querySelector('.test_select');
                
                if(addButton) {
                    addButton.style.display = "inline-block";
                }
                if(variantSelector) {
                    variantSelector.style.display = "none";
                }
                
                if(addButton && addButton.dataset.handle){
                    productItem.classList.remove(addButton.dataset.handle + "-selected");
                }
            }
            window.BundleInfo.splice(bundleIndex, 1);
            updatSelectedData();
            setButtonState();
            return;
        }
        if(typeof window.IsNotWarned !== 'undefined'){
            window.IsNotWarned = true;
        }
    }

    if(quantity_display){
        quantity_display.value = bundle.quantity;
        quantity_display.setAttribute("value", bundle.quantity);
    }
    
    updatSelectedData();

    if((window.BundleSize - getTotalBundleSize() == 0)){
        if(typeof window.IsNotWarned !== 'undefined'){
            window.IsNotWarned = false;
        }
    }

    setButtonState();
}

function bundleProduct(id,image,price,quantity){
    return JSON.parse(`{"variantId" : "${id}", "variantImage" : "${image}", "price" : "${price}", "quantity": "${quantity}"}`)
}

function isInBundle(id){
    let found = -1;
    let position = 0;
    window.BundleInfo.forEach((bundle) => {
        if(bundle.variantId == id){
            found = position;
        }
        position++;
    })
    return found;
}

function getTotalBundleSize(){
    let size = 0;
    for(let i = 0; i < window.BundleInfo.length; i++){
        let bundle = window.BundleInfo[i];
        size = Number(size) + Number(bundle.quantity);
    }
    return size;
}

function removeBundlerItem(element) {
    if(!element.dataset.remove) return;
    
    let img = element.previousElementSibling;
    if(!img) return;
    
    let bundleIndex = isInBundle(element.dataset.remove);
    if(bundleIndex == -1) return;
    
    // Remove from bundle
    window.BundleInfo.splice(bundleIndex, 1);
    
    // Find the product button for this variant and restore it
    const variantId = element.dataset.remove;
    const productItems = document.querySelectorAll('.product-grid-item');
    
    productItems.forEach(item => {
        const variantSelector = item.querySelector('.test_select');
        const addButton = item.querySelector('.product-button');
        const quantityControl = item.querySelector('.quantity-control');
        
        if(variantSelector){
            const options = variantSelector.querySelectorAll('option.variant_option');
            options.forEach(option => {
                if(option.dataset.variantid === variantId){
                    // Reset the product item state
                    if(addButton){
                        addButton.style.display = 'inline-block';
                    }
                    if(quantityControl){
                        quantityControl.style.display = 'none';
                    }
                    variantSelector.style.display = 'none';
                    if(addButton && addButton.dataset.handle){
                        item.classList.remove(addButton.dataset.handle + "-selected");
                    }
                }
            });
        } else if(addButton && addButton.dataset.default === variantId){
            // Single variant product
            addButton.style.display = 'inline-block';
            if(quantityControl){
                quantityControl.style.display = 'none';
            }
            if(addButton.dataset.handle){
                item.classList.remove(addButton.dataset.handle + "-selected");
            }
        }
    });
    
    // Update UI
    removeOldRemovalButtons();
    updatSelectedData();
    setButtonState();
}

function removeOldRemovalButtons(){
    let images = document.querySelectorAll('.product-selected-placeholders');

    for(let i = 0; i < images.length; i++ ){
        let img = images[i];
        if(img.src.includes('placeholder')){
            let remove_button = img.nextElementSibling;
            remove_button.removeAttribute('data-remove');
            remove_button.style.display = "none"
        }

    }
}

function updateHeaderText() {
    let totalItemsNeeded = window.BundleSize - getTotalBundleSize();
    let headerText = document.querySelectorAll(".right_text_main");

    if (totalItemsNeeded <= 0 && getTotalBundleSize() > 0) { // Check if the bundle is complete or partially filled
        headerText.forEach(element => {
            element.innerHTML = "Bundle Complete!"; // or use `ADD 0 MORE PRODUCTS` if preferred
        });
    } else if (getTotalBundleSize() == 0) { // Reset to original when no products are in the bundle
        headerText.forEach(element => {
            element.innerHTML = window.originalHeaderText; // Use the stored original header text
        });
    } else { // Otherwise, ask to add more products
        headerText.forEach(element => {
            element.innerHTML = `ADD ${totalItemsNeeded} MORE ${totalItemsNeeded === 1 ? 'PRODUCT' : 'PRODUCTS'}`;
        });
    }
}

window.placeholder_images = [
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-1_200x.png?v=82680836825255707981765849054",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-2_200x.png?v=172943580824846899221765849055",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-3_200x.png?v=9196144944680286841765849055",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-4_200x.png?v=177906918868515401601765849055",
  
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-1st-2_200x.png?v=98178211547076937891765849056",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-2nd-2_200x.png?v=115573015504621094871765849056",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-3rd-2_200x.png?v=17784570349404456431765849054",
    "//ambrosiacollective.com/cdn/shop/t/116/assets/placeholder-all-add-4th-2_200x.png?v=41396826915142762781765849055"
];

function updatSelectedData() {
    // Get all placeholders
    const desktopPlaceholders = document.getElementsByClassName("product-selected-placeholders");
    const mobilePlaceholders = document.getElementsByClassName("product-selected-placeholder-mobile");
    
    // First, reset all placeholders to default images and hide all remove buttons
    for (let i = 0; i < window.BundleSize; i++) {
        if (i < desktopPlaceholders.length) {
            desktopPlaceholders[i].src = window.placeholder_images[i % window.placeholder_images.length];
            const removalButtonDesktop = desktopPlaceholders[i].nextElementSibling;
            if (removalButtonDesktop && removalButtonDesktop.classList.contains("remove-item")) {
                removalButtonDesktop.style.display = "none";
                removalButtonDesktop.removeAttribute('data-remove');
            }
        }
        if (i < mobilePlaceholders.length) {
            mobilePlaceholders[i].src = window.placeholder_images[i % window.placeholder_images.length];
            const removalButtonMobile = mobilePlaceholders[i].nextElementSibling;
            if (removalButtonMobile && removalButtonMobile.classList.contains("remove-item")) {
                removalButtonMobile.style.display = "none";
                removalButtonMobile.removeAttribute('data-remove');
            }
        }
    }

    // Now update placeholders with actual product images
    let img_place = 0;
    
    // Iterate through all bundles in BundleInfo
    for (let i = 0; i < window.BundleInfo.length; i++) {
        let bundle = window.BundleInfo[i];
        if (!bundle || !bundle.variantId) continue;
        
        // For each quantity of this bundle item
        const quantity = Number(bundle.quantity) || 1;
        for (let j = 0; j < quantity; j++) {
            // Check if we have enough placeholders
            if (img_place >= desktopPlaceholders.length || img_place >= mobilePlaceholders.length) {
                break;
            }
            
            let desktopPlaceholder = desktopPlaceholders[img_place];
            let mobilePlaceholder = mobilePlaceholders[img_place];
            
            if (!desktopPlaceholder || !mobilePlaceholder) {
                break;
            }

            // Set product image if available - ensure we use the actual image URL
            if (bundle.variantImage && bundle.variantImage.trim() !== '') {
                // Ensure image URL is absolute
                let imageUrl = bundle.variantImage;
                if (imageUrl.startsWith('//')) {
                    imageUrl = window.location.protocol + imageUrl;
                } else if (imageUrl.startsWith('/')) {
                    imageUrl = window.location.origin + imageUrl;
                }
                desktopPlaceholder.src = imageUrl;
                mobilePlaceholder.src = imageUrl;
            }

            // Show and configure remove buttons
            const removalButtonMobile = mobilePlaceholder.nextElementSibling;
            const removalButtonDesktop = desktopPlaceholder.nextElementSibling;
            
            if (removalButtonMobile && removalButtonMobile.classList.contains("remove-item")) {
                removalButtonMobile.style.display = "block";
                removalButtonMobile.setAttribute('data-remove', bundle.variantId);
            }
            
            if (removalButtonDesktop && removalButtonDesktop.classList.contains("remove-item")) {
                removalButtonDesktop.style.display = "block";
                removalButtonDesktop.setAttribute('data-remove', bundle.variantId);
            }
            
            img_place++;
        }
    }
    
    // Update quantity controls to match bundle quantities
    updateQuantityControls();

    // Update prices
    getTotalPrice();
    
    // Update button states
    setButtonState();
  
    // Update subtext visibility
    updateSubTextVisibility();
  
    // Update header text
    updateHeaderText();
}

function updateQuantityControls() {
    // Update all quantity controls to reflect current bundle quantities
    const quantityControls = document.querySelectorAll('.quantity-control');
    
    quantityControls.forEach(control => {
        const variantId = control.dataset.variant;
        if (!variantId) return;
        
        const bundleIndex = isInBundle(variantId);
        if (bundleIndex !== -1) {
            const bundle = window.BundleInfo[bundleIndex];
            if (bundle) {
                const quantityInput = control.querySelector('.quantity-input');
                if (quantityInput) {
                    quantityInput.value = bundle.quantity;
                    quantityInput.setAttribute('value', bundle.quantity);
                }
            }
        }
    });
}

function updateSubTextVisibility() {
    let rightTextSub = document.querySelector(".right_text_sub"); // Selector for the desktop version
    let rightTextSubMobile = document.querySelector(".right_text_sub_mobile"); // Selector for the mobile version

    let totalItems = getTotalBundleSize();
    if (totalItems >= window.BundleSize) {
        // Hide the sub texts when the bundle is complete
        if (rightTextSub) rightTextSub.style.display = 'none';
        if (rightTextSubMobile) rightTextSubMobile.style.display = 'none';
    } else {
        // Show the sub texts when the bundle is incomplete
        if (rightTextSub) rightTextSub.style.display = 'block';
        if (rightTextSubMobile) rightTextSubMobile.style.display = 'block';
    }
}



function setButtonState() {
    let atc_buttons = document.getElementsByClassName("product-button_atc");
    
    for (let i = 0; i < atc_buttons.length; i++) {
        let button = atc_buttons[i];
        let totalItems = getTotalBundleSize();
        let itemsNeededToAdd = window.BundleSize - totalItems;

        if (totalItems == 0) {
            button.innerHTML = "ADD A PRODUCT TO GET STARTED";
            button.setAttribute("disabled", "");
        } else if (totalItems >= window.BundleSize) {
            button.innerHTML = "BUY NOW";
            button.removeAttribute("disabled");
        } else {
            button.innerHTML = `ADD ${itemsNeededToAdd} MORE ${itemsNeededToAdd == 1 ? "PRODUCT" : "PRODUCTS"}`;
            button.removeAttribute("disabled");
        }
    }

    // Ensure the header text is also updated
    updateHeaderText();
}



function getTotalPrice(){
    let total = 0;
    let bundler = window.BundleInfo;

    // Calculate total (prices are already in dollars from bundleProduct function)
      for(let i = 0; i < bundler.length; i++){
        let bundle = window.BundleInfo[i];
        if(bundle && bundle.price && bundle.quantity) {
            total = total + (Number(bundle.price) * Number(bundle.quantity));
        }
    }

    // Calculate discounted price (10% off)
    const discountedPrice = total * 0.9; // 10% discount
    
    // Update price displays (handle both desktop and mobile)
    const priceElements = document.getElementsByClassName("right_text_price");
    for(let i = 0; i < priceElements.length; i++){
        priceElements[i].innerHTML = `$${discountedPrice.toFixed(2)}`;
    }

    // Update retail price (original price before discount)
    const retail_price = document.getElementsByClassName("price_retail");
    for(let i = 0; i < retail_price.length; i++){
        if(total > 0){
            retail_price[i].innerHTML = `$${total.toFixed(2)}`;
            retail_price[i].style.display = "block";
        } else {
            retail_price[i].innerHTML = "$0.00";
            retail_price[i].style.display = "none";
        }
    }

    return `$${discountedPrice.toFixed(2)}`;
}

  async function addBundlerItemsToCart(){
    // Validate bundle before adding
    if (!window.BundleInfo || window.BundleInfo.length === 0) {
      alert('Please add at least one product to your bundle.');
      return;
    }

    // Get all add to cart buttons and disable them during the process
    const atcButtons = document.querySelectorAll('.product-button_atc');
    const originalButtonTexts = [];
    atcButtons.forEach((button, index) => {
      originalButtonTexts[index] = button.innerHTML;
      button.setAttribute('disabled', '');
      button.innerHTML = 'ADDING TO CART...';
      button.style.opacity = '0.6';
    });

    // Get cart drawer element
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    
    try {
      // Build FormData for multiple items (following product-form.js pattern)
      const formData = new FormData();
      
      window.BundleInfo.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.variantId);
        formData.append(`items[${index}][quantity]`, parseInt(item.quantity) || 1);
        // Add bundle property
        formData.append(`items[${index}][properties][_bundle]`, 'true');
      });

      // Add sections for cart rendering if cart drawer is available (following product-form.js pattern)
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      // Use fetchConfig following product-form.js pattern
      const config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: { 'Accept': 'application/javascript' }
      };
      
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type']; // Let browser set Content-Type for FormData
      config.body = formData;

      // Determine cart add URL
      const cartAddUrl = (typeof window.routes !== 'undefined' && window.routes.cart_add_url) 
        ? window.routes.cart_add_url 
        : '/cart/add';

      // Add all items to cart at once
      const response = await fetch(cartAddUrl, config);
      const responseData = await response.json().catch(() => ({}));

      // Handle errors (following product-form.js pattern)
      if (responseData.status) {
        // Publish cart error event if available
        if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'bundler',
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          });
        }
        throw new Error(responseData.description || responseData.message || 'Failed to add items to cart');
      }

      // If no cart drawer, redirect to cart page
      if (!cart) {
        window.location = (typeof window.routes !== 'undefined' && window.routes.cart_url) 
          ? window.routes.cart_url 
          : '/cart';
        return;
      }

      // Publish cart update event (following product-form.js pattern)
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
        const startMarker = typeof CartPerformance !== 'undefined' 
          ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
          : null;
        
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bundler',
          cartData: responseData,
        }).then(() => {
          if (startMarker && typeof CartPerformance !== 'undefined') {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          }
        });
      }

      // Render cart contents (following product-form.js pattern)
      if (typeof cart.renderContents === 'function') {
        if (typeof CartPerformance !== 'undefined') {
          CartPerformance.measure("add:paint-updated-sections", () => {
            cart.renderContents(responseData);
          });
        } else {
          cart.renderContents(responseData);
        }
      }

      // Remove empty class from cart if present
      if (cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }

      // Show notification if available
      TriggerBundlerAddNotification();

      // Reset bundle after successful add
      window.BundleInfo = [];
      updatSelectedData();
setButtonState();

    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      alert(error.message || 'There was an error adding your bundle to the cart. Please try again.');
    } finally {
      // Restore button states
      atcButtons.forEach((button, index) => {
        button.removeAttribute('disabled');
        button.innerHTML = originalButtonTexts[index] || 'ADD TO CART';
        button.style.opacity = '1';
      });
    }
  }


  function hideAddButtons(callback){
      let add_buttons = document.querySelectorAll(".product-button");

      add_buttons.forEach((button) =>{
          button.setAttribute("disabled","");
          button.style.opacity = 0.6;
      })
  }

  function showAddButtons(){
    let add_buttons = document.querySelectorAll(".product-button");

    add_buttons.forEach((button) =>{
        button.removeAttribute("disabled");
        button.style.opacity =1;
    })
}

function TriggerBundlerAddNotification() {
    let notiBar = document.getElementById("notification");
    notiBar.style.display = "flex";
    notiBar.classList.remove("animation");
    void notiBar.offsetHeight;
    notiBar.classList.add("animation");
}

document.addEventListener('scroll', function() {
    const container = document.querySelector('.product-selected-container');
    if (!container) return;
    
    const stickyRight = container.querySelector('.sticky-right');
    if (!stickyRight) return;
    
    const containerParent = container.parentElement;
    if (!containerParent) return;
    
    const containerTop = containerParent.offsetTop;
    const containerHeight = containerParent.offsetHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollBottom = containerTop + containerHeight;
    const stickyHeight = stickyRight.offsetHeight;
    
    if (scrollTop < containerTop) {
        stickyRight.style.position = 'relative';
        stickyRight.style.top = '0';
        container.style.alignSelf = 'flex-start';
    } else if (scrollTop > containerTop) {
        stickyRight.style.position = 'fixed';
        stickyRight.style.top = '100px';
    }
    
    if (scrollTop > scrollBottom - stickyHeight - 150) {
        stickyRight.style.position = 'relative';
        stickyRight.style.top = '-50px';
        stickyRight.style.padding = '80px';
        container.style.alignSelf = 'flex-end';
    }
});